import React, { useEffect, useState } from "react";
import {
  Box,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  makeStyles,
  withStyles,
  Button,
  Typography,
  Backdrop,
  Fade,
  Modal,
  Paper,
  FormControl,
  NativeSelect,
  Input,
  TextareaAutosize,
  CircularProgress,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// css
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
    background: "#ebf2f3",
    color: "#000",
    borderBottom: "3px solid #FFF",
    padding: "10px 16px",
    lineHeight: "40px",
    fontWeight: "700 !important",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "5px",
    align: "left",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },

  innerTableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "5px",
    align: "left",
    verticalAlign: "sub",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    boxShadow: theme.shadows[2],
    borderRadius: "12px",
    padding: theme.spacing(2),
    minWidth: "300px",
    minHeight: "400px",
    maxWidth: "700px",
    [theme.breakpoints.up("sm")]: {
      minWidth: "500px",
    },
  },
  paperModal: {
    backgroundColor: "#fff",
    boxShadow: theme.shadows[2],
    borderRadius: "12px",
    padding: theme.spacing(2),
    minWidth: "300px",
    minHeight: "400px",
    maxWidth: "600px",
    [theme.breakpoints.up("sm")]: {
      minWidth: "500px",
    },
  },
  input: {
    width: "90% !important",
  },
  filterBar: {
    display: "flex",
    gap: "10px",
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
}));
// end of css

// const base_url = "http://localhost:4000";
const base_url = "https://api.careerroshi.com";

const OrderDetail = ({id}) => {

  const classes = useStyles();
  // const { user } = useSelector((state) => state.auth);
  const [user, setUser] = useState(null);
  const headers = ["ID", "Date", "Organization", "Item", "Type", ""];

  const [orderDetailRows, setOrderDetailRows] = useState([]);
  const [pending, setPending] = useState(false);

  const getTranscations = async (obj = null, type = 'program') => {
    setPending(true);
    let filter_value = filter;
    if (obj) {
      filter_value = obj;
    }
    try {
      let res = await axios.get(`${base_url}/jobseeker/combine/transcation`, {
        params: {
          userId: id,
          ...filter_value,
          type: type
        },
      });
      let data = res.data;

      let _data = data.data.map((item) => {
        if (item.type == "program") {
          let obj = {
            ...item,
            type: "program",
            date: moment(item.purchase_date).format("MM/DD/YYYY HH:mm"),
            total: `${item.price}`,
            qty: 1,
            item: item.transaction_details.metadata.programTitle,
          };
          return obj;
        } else {
          let obj = {
            ...item,
            type: "service",
            date: moment(item.createdAt).format("MM/DD/YYYY HH:mm"),
            total: `${item.amount}`,
            qty: 1,
            item: item.serviceTitle,
          };
          return obj;
        }
      });
      setOrderDetailRows(_data);
      console.log(data);
    } catch (ex) {
      let error = ex.response ? ex.response.data.message : ex.message;
      alert(error);
    } finally {
      setPending(false);
    }
  };

  const getUser = async () => {
    try{
      let res = await axios.get(`${base_url}/user/${id}`);
      let data = res.data;
      setUser(data.data);
    }catch(ex){
      console.error(ex);
    }
  }

  useEffect(() => {
    getTranscations();
    getUser()
  }, []);
  const innerColumn = ["Items", "Organization" ,"Qty"];

  const [innerRows, setInnerRows] = React.useState([
    {
      item: `<h5>Vet Assistent</h5><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic</p>`,
      qty: 1,
      unitPrice: "$2.00",
      amount: "$2.00",
    },
  ]);
  const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [refundReason, setRefundReason] = React.useState("");
  const [filter, setFilter] = React.useState({
    from: "",
    to: "",
    status: "",
    item: "",
  });
  const [type, setType] = React.useState("program");
  const handleClearFilter = () => {
    setFilter({
      from: "",
      to: "",
      status: "",
      item: "",
    });
    getTranscations({
      from: "",
      to: "",
      status: "",
      item: "",
    });
  };

  const handleChangeType = (e) => {
    setType(e.target.value);
    getTranscations(null, e.target.value);
  }

  const handleSearch = () => {
    getTranscations();
  };

  const handleOpen = (obj) => {
    console.log(obj);

    let description = "";
    let payment_id = "";
    if (obj.type == "service") {
      payment_id = obj.payment_intent;
      if (obj.serviceId && obj.serviceId.discription) {
        description = obj.serviceId.discription;
      }
    } else {
      payment_id = obj.transaction_details.payment_intent;
      if (obj.program && obj.program.program_description) {
        description = obj.program.program_description;
      }
    }
    let array = [
      {
        item: `<h5>${obj.item}</h5><p>${description}</p>`,
        qty: obj.qty,
        unitPrice: `${obj.total / obj.qty}`,
        amount: `${obj.total}`,
        other: obj,
        payment_id: payment_id,
      },
    ];
    setInnerRows([...array]);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleReOrder = async (row) => {
    if(row.type == "program"){
      if(!row.org || !row.org.slug || !row.program || !row.program.slug){
        alert("Program Deleted");
        return ;
      }
      let anchar = document.createElement("a");
      anchar.href = `https://careertrainingprogram.vercel.app/${row.org.slug}/programs/${row.program.slug}`
      anchar.setAttribute("target", "_blank");
      anchar.click();
    }else if(row.type == 'service'){
      if(!row.serviceOwner && !row.serviceOwner._id){
        alert("Service Deleted");
        return ;
      }
      let anchar = document.createElement("a");
      anchar.href = `https://marketplace.workforcefortune.com/coach/${row.serviceOwner._id}/services`;
      anchar.setAttribute("target", "_blank");
      anchar.click();
    }
    console.log(row);
    // if(type)
  }

  return (
    <Box style={{ marginTop: 7 }} className="mt-10">
      <h2 style={{ margin: "10px 0px" }}>Career Training</h2>
      <Box className={classes.filterBar}>
        <FormControl className={classes.formControl}>
          <Typography variant="h6" style={{ marginBottom: "5px" }}>
            From Date
          </Typography>
          <Input
            placeholder="Select Date"
            type="date"
            value={filter.from}
            onChange={(e) => {
              setFilter((pre) => ({ ...pre, from: e.target.value }));
            }}
          />
        </FormControl>

        <FormControl className={classes.formControl}>
          <Typography variant="h6" style={{ marginBottom: "5px" }}>
            To Date
          </Typography>
          <Input
            placeholder="Select Date"
            type="date"
            value={filter.to}
            onChange={(e) => {
              setFilter((pre) => ({ ...pre, to: e.target.value }));
            }}
          />
        </FormControl>

        <FormControl className={classes.formControl}>
          <Typography variant="h6" style={{ marginBottom: "5px" }}>
            Status
          </Typography>
          <NativeSelect
            name="age"
            inputProps={{ "aria-label": "age" }}
            value={filter.status}
            onChange={(e) => {
              setFilter((pre) => ({ ...pre, status: e.target.value }));
            }}
          >
            <option value="">Please Select</option>
            <option value={"paid"}>Paid</option>
            <option value={"refunded"}>Refunded</option>
            <option value={"refund-requested"}>Refund Requested</option>
          </NativeSelect>
        </FormControl>

        <FormControl className={classes.formControl}>
          <Typography variant="h6" style={{ marginBottom: "5px" }}>
            Item
          </Typography>
          <Input
            placeholder="Enter Item"
            value={filter.item}
            onChange={(e) => {
              e.persist();
                setFilter((prev) => ({ ...prev, item: e.target.value }));
              }}
            onKeyDown={(e)=>{
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
              />
            </FormControl>
            <Box style={{ display: "flex", gap: 5, alignItems: "center" }}>
              <Button onClick={handleClearFilter}>Clear</Button>
              <Button
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              onClick={handleSearch}
              >
              Search
              </Button>
            </Box>
            </Box>
            {/* <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "25px" }}>
            <Typography variant="h6" style={{ marginBottom: "5px" }}>
              Status
            </Typography>
            <NativeSelect
              name="age"
              inputProps={{ "aria-label": "age" }}
              value={filter.status}
              onChange={handleChangeType}
            >
              <option value={"service"}>Service</option>
              <option value={"program"}>Program</option>
            </NativeSelect>
            </div> */}
            <TableContainer className="mt-5 border">
            <Table
              aria-label="simple table"
              style={{ minWidth: "800px", overflowX: "auto" }}
            >
              {/* Table Header */}
          <TableHead>
            <TableRow>
              {headers.map((item, index) => (
                <TableCell
                  key={index}
                  align="left"
                  classes={{ root: classes.tableHeadCell }}
                >
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    {item}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {/* Table Body */}
          <TableBody>
            {orderDetailRows.length == 0 && !pending && (
              <StyledTableRow
                // hover={true}
                selected={false}
              >
                <TableCell colSpan={7} align="center">
                  <p>No Traning Order History</p>
                </TableCell>
              </StyledTableRow>
            )}
            {pending && (
              <StyledTableRow
                // hover={true}
                selected={false}
              >
                <TableCell colSpan={7} align="center">
                  <CircularProgress style={{ color: "#3699FF" }} />
                </TableCell>
              </StyledTableRow>
            )}
            {!pending &&
              orderDetailRows.map((row, index) => (
                <StyledTableRow
                  // hover={true}
                  selected={false}
                  key={index}
                >
                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                  >
                    {row._id}
                  </TableCell>
                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                  >
                    {row.date}
                  </TableCell>
                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                  >
                    {row.org && row.org.name || "N/A"} 
                  </TableCell>

                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                  >
                    {row.item}
                  </TableCell>
                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                  >
                    {row.type}
                  </TableCell>
                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    style={{ display: "flex", gap: "10px" }}
                    component="th"
                    scope="row"
                    align="left"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ color: "white" }}
                      onClick={()=>{ handleOpen(row) }}
                    >
                      View
                    </Button>

                    <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      className={classes.modal}
                      open={open}
                      onClose={handleClose}
                      closeAfterTransition
                      BackdropComponent={Backdrop}
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade in={open}>
                        <Paper className={classes.paper}>
                          <Box
                            style={{
                              borderBottom: "1px solid #CCCCCC",
                              paddingBottom: "5px",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="h5"
                              id="transition-modal-title"
                            >
                              Detailed View
                            </Typography>
                            <Box
                              onClick={handleClose}
                              style={{
                                cursor: "pointer",
                                height: "25px",
                                width: "25px",
                                borderRadius: "25px",
                                backgroundColor: "red",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <ClearIcon style={{ color: "white" }} />
                            </Box>
                          </Box>
                          <Box
                            style={{
                              marginTop: "15px",
                              display: "flex",
                              gap: "30px",
                            }}
                          >
                            <Typography variant="body1">Customer</Typography>
                            <Box>
                              <Typography variant="body1">
                                {user && user.email}
                              </Typography>
                              <Typography
                                variant="body1"
                                style={{ marginTop: "5px" }}
                              >
                                {user && user.firstName} {user && user.lastName}
                              </Typography>
                              {user && user.address && (
                                <>
                                  <Typography variant="body1">
                                    {user.address}
                                  </Typography>
                                </>
                              )}
                            </Box>
                          </Box>
                          {/* Inner Table */}
                          <Box style={{ marginTop: "20px" }}>
                            <TableContainer className="mt-10 border">
                              <Table
                                aria-label="simple table"
                                style={{ minWidth: "600px", overflowX: "auto" }}
                              >
                                {/* Inner Table Header */}
                                <TableHead>
                                  <TableRow>
                                    {innerColumn.map((item, index) => (
                                      <TableCell
                                        key={index}
                                        align="left"
                                        classes={{
                                          root: classes.tableHeadCell,
                                        }}
                                      >
                                        <Typography
                                          variant="h6"
                                          style={{
                                            fontWeight: 600,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {item}
                                        </Typography>
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                {/* Inner Table Body */}
                                <TableBody>
                                  {innerRows.map((row, index) => (
                                    <StyledTableRow
                                      // hover={true}
                                      selected={false}
                                      key={index}
                                    >
                                      <TableCell
                                        classes={{
                                          root: `${classes.innerTableRowCell} text-capitalize`,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                      >
                                        <Box
                                          style={{ lineHeight: "normal" }}
                                          dangerouslySetInnerHTML={{
                                            __html: row.item,
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell
                                        classes={{
                                          root: `${classes.innerTableRowCell} text-capitalize`,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                      >
                                        {row.other && row.other.org && row.other.org.name || "N/A"}
                                      </TableCell>
                                      <TableCell
                                        classes={{
                                          root: `${classes.innerTableRowCell} text-capitalize`,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                      >
                                        {row.qty}
                                      </TableCell>
                                      {/* <TableCell
                                        classes={{
                                          root: `${classes.innerTableRowCell} text-capitalize`,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                      >
                                        {row.unitPrice}
                                      </TableCell>
                                      <TableCell
                                        classes={{
                                          root: `${classes.innerTableRowCell} text-capitalize`,
                                        }}
                                        component="th"
                                        scope="row"
                                        align="left"
                                      >
                                        ${row.unitPrice}
                                      </TableCell> */}
                                    </StyledTableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                          <Box
                            style={{
                              marginTop: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: "12px",
                            }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              style={{ color: "white" }}
                              onClick={handleClose}
                            >
                              Close
                            </Button>
                          </Box>
                        </Paper>
                      </Fade>
                    </Modal>
                  </TableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderDetail;
